import { IExportarExtratoRequest } from '../entities/IExportarExtratoRequest'
import { IExportarExtratoResponse } from '../entities/IExportarExtratoResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IExportarExtrato {
  execute(params: IExportarExtratoRequest): Promise<IExportarExtratoResponse>
}

export default class ExportarExtratoImpl implements IExportarExtrato {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(
    params: IExportarExtratoRequest,
  ): Promise<IExportarExtratoResponse> {
    return this.pagamentosRepository.exportarExtrato(params)
  }
}
